import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { Button, Label } from '../../atoms';
import cn from 'classnames';
import styles from './LandscapeTextBlockEditTemplate.module.css';
import { RichTextBlockResponseDto } from '../../../store/landscapeAPI/block/dto/response/rich-text-block-response.dto';
import { LandscapeTextBlockOrganism } from '../../organisms';
import { useNavigate, useParams } from 'react-router-dom';

export interface LandscapeTextBlockEditTemplateProps {
  handleOnChange: (textBlock: RichTextBlockResponseDto) => void;
  textBlock: RichTextBlockResponseDto;
  callbackFn: (textBlock: RichTextBlockResponseDto) => void;
}

const LandscapeTextBlockEditTemplate: FC<
  LandscapeTextBlockEditTemplateProps
> = ({ handleOnChange, textBlock, callbackFn }) => {
  const { id, storyId } = useParams();
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Update Text Block" size="lg" />
          <Button
            className={styles.buttonLink}
            onClick={() =>
              navigate(
                `/landscapes/edit/${id}/updates/story/edit/${storyId}/content-blocks`
              )
            }
            variant="link"
          >
            Go back
          </Button>
        </div>
        <LandscapeTextBlockOrganism
          handleOnChange={handleOnChange}
          textBlock={textBlock}
          callbackFn={callbackFn}
        />
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeTextBlockEditTemplate;
